import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const HeaderNotificationWrapper = styled.div`
  display: flex;
  .notificationBg {
    display: flex;
    background-color: ${COLORS.primary_light_blue2};
    border-radius: 8px;
    margin-right: 24px;
    padding: 9px;
    height: 40px;
    align-items: center;

    ${responsive.MOBILE`
      margin-right: 8px;
    `}
  }
  .notificationIcon {
    width: 24px;
    height: 24px;
  }
`;
